import { BodyData } from './http-client.interfaces';

export function getContentType(data: BodyData) {
  if (typeof data === 'string') {
    return 'text/plain';
  }

  if (data instanceof FormData) {
    return 'multipart/form-data';
  }

  if (data instanceof URLSearchParams) {
    return 'application/x-www-form-urlencoded';
  }

  return 'application/json';
}
